import PageShell from "@/components/PageShell";
import SignalementSection from "@/components/home/SignalementSection";
import { Lightbulb, MessageCircle, Info, AlertTriangle, Sparkles, MapPin, Shield } from "lucide-react";

export default function IdeesPage() {
  return (
    <PageShell>
      {/* Hero header — boxed */}
      <section className="bg-gradient-to-br from-cream-50 via-pink-50/30 to-cream-50 border-b border-cream-200/60">
        <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-8 py-10 sm:py-14 text-center">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-pink-100 text-pink-600 text-[11px] font-bold uppercase tracking-[0.18em] mb-4 border border-pink-200">
            <Sparkles size={11} strokeWidth={2.5} /> Boîte à idées Istres
          </div>
          <h1 className="heading-display text-[2rem] sm:text-[2.6rem] lg:text-[3rem] text-plum-900 leading-[1.05]">
            Une idée pour Istres&nbsp;?
            <br />
            <span className="text-pink-600">Partagez-la avec la mairie.</span>
          </h1>
          <p className="text-[14px] sm:text-[15px] text-plum-700/75 mt-4 max-w-2xl mx-auto leading-relaxed">
            Suggestion, projet citoyen, signalement ou simple question — chaque message déposé ici
            est lu et étudié par les services municipaux. Vous serez notifié de la suite donnée.
          </p>

          {/* Type pills mini summary */}
          <div className="mt-7 flex flex-wrap items-center justify-center gap-2" aria-label="Types de remontées">
            <TypePill icon={Lightbulb} label="Idée"      color="bg-sun-100 text-sun-700 border-sun-200" />
            <TypePill icon={MessageCircle} label="Avis"   color="bg-mint-100 text-mint-700 border-mint-200" />
            <TypePill icon={Info} label="Question"        color="bg-plum-100 text-plum-700 border-plum-200" />
            <TypePill icon={AlertTriangle} label="Problème" color="bg-pink-100 text-pink-600 border-pink-200" />
          </div>

          {/* Reassurance row */}
          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[11px] text-plum-700/55">
            <span className="inline-flex items-center gap-1"><MapPin size={11} /> Géolocalisation optionnelle</span>
            <span className="text-plum-700/25">·</span>
            <span className="inline-flex items-center gap-1"><Shield size={11} /> Données protégées RGPD</span>
            <span className="text-plum-700/25">·</span>
            <span className="inline-flex items-center gap-1">Réponse sous 5 jours ouvrés</span>
          </div>
        </div>
      </section>

      {/* Form — boxed */}
      <section className="bg-cream-50">
        <div className="max-w-3xl mx-auto px-5 sm:px-6 lg:px-8 py-10 sm:py-14">
          <SignalementSection />
        </div>
      </section>
    </PageShell>
  );
}

function TypePill({ icon: Icon, label, color }) {
  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border ${color} text-[12px] font-bold`}>
      <Icon size={12} strokeWidth={2.4} />
      {label}
    </span>
  );
}
